import React from 'react'
import classnames from 'classnames/bind'
import type { AuctionBlueprintOnlineReactiveArgs } from '@adc/blueprint'
import BidHistory from 'common/modules/bidHistory'
import BidHistoryTrigger from './trigger'
// @ts-ignore no types
import styles from './styles.scss'
const cx = classnames.bind(styles)

interface BidHistorySectionProps {
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
  featureFlags: any
}

export const BidHistorySection = ({
  listing,
  featureFlags,
}: BidHistorySectionProps) => {
  return (
    <div className={cx('container')}>
      <BidHistory
        listing={listing}
        featureFlags={featureFlags}
        trigger={<BidHistoryTrigger />}
      />
    </div>
  )
}
